import { COLLECTIONS } from "constants/action-types";
import type { IAllocationDimension } from "helpers/allocation-dimension";
import { FluxStandardAction as Action } from "flux-standard-action";
import type { ISchemaKey } from "helpers/product-collection";

export type UpdateAllocationDimensionAttributeRequestAction = Action<
    {
        allocationDimensionAttribute: ISchemaKey[];
    },
    {
        objectId: string;
    }
>;
export const updateAllocationDimensionAttributeRequest = (
    allocationDimensionAttribute: ISchemaKey[],
    objectId: string
): UpdateAllocationDimensionAttributeRequestAction => ({
    meta: { objectId },
    payload: {
        allocationDimensionAttribute,
    },
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.ATTRIBUTES.UPDATE.REQUEST,
});

export type UpdateAllocationDimensionAttributeCompleteAction = Action<
    IAllocationDimension | Error,
    {
        objectId: string;
    }
>;
export const updateAllocationDimensionAttributeComplete = (
    payload: IAllocationDimension | Error,
    objectId: string
): UpdateAllocationDimensionAttributeCompleteAction => ({
    meta: { objectId },
    payload,
    error: payload instanceof Error,
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.ATTRIBUTES.UPDATE.COMPLETE,
});

export type AddUpdateAllocationDimensionAttributeRequestAction = Action<
    {
        allocationDimensionAttributes: ISchemaKey[];
        indexToItemMap?: Map<number, any>;
    },
    {
        objectId: string;
    }
>;

/**
 * Action for adding/updating allocation dimension (attributes)
 * and updating dimension value for a attribute.
 * @param allocationDimensionAttributes - allocation dimension attributes. If null, add/update alloc dim operation will be skipped. Only set dimension
 * value will be fired.
 * @param objectId
 * @param indexToItemMap - rowIndex to rowData map.
 * @returns
 */
export const addAllocationDimensionAttributeAndUpdateValueRequest = (
    allocationDimensionAttributes: ISchemaKey[],
    objectId: string,
    indexToItemMap?: Map<number, any>
): AddUpdateAllocationDimensionAttributeRequestAction => ({
    meta: { objectId },
    payload: {
        allocationDimensionAttributes,

        indexToItemMap,
    },
    type: COLLECTIONS.COLLECTION.ALLOCATION_DIMENSION.ATTRIBUTES.ADD_UPDATE.REQUEST,
});
